/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:8e1824e6-b13e-4d00-ab53-1a454ba9e6f2",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_gkAEKnfdq",
    "aws_user_pools_web_client_id": "4v0dhgvmabrp82skjltfel16vh",
    "oauth": {}
};


export default awsmobile;
